


































































































































































































import Vue from "vue";
import Multiselect from "@/components/ui/Multiselect.vue";
import SmallTable, { Header } from "@/components/ui/SmallTable.vue";
import Fieldset from "@/components/ui/Fieldset.vue";
import SaveDialog from "@/components/dialog/SaveDialog.vue";

import {
  Gewzv,
  Hochwasserpartnerschaften,
  IBH,
  Regionalstelle,
  Risikogewaesser,
  Rolle,
  Schlagwort,
} from "@/types";
import { Kommune } from "@/types/Kommune";
import { erklServiceInstance } from "@/services/ErklService";
import AlertService from "@/services/libs/AlertService";
import { kommunenServiceInstance } from "@/services/KommunenService";
import { alertError } from "@/services/ErrorAlert";
import { RequestError } from "@/services/AuthService";
import ValidationService from "@/services/ValidationService";
import PubSub from "pubsub-js";
import ContactTable from "@/components/ui/ContactTable.vue";
import { Ansprechpartner } from "@/types/Ansprechpartner";

export default Vue.extend({
  name: "StammdatenTab",
  components: {
    ContactTable,
    Fieldset,
    Multiselect,
    SmallTable,
    SaveDialog,
  },
  props: {
    /** kommune id */
    id: {
      type: [String, Number],
      required: true,
    },
    /** edit mode */
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      isLoading: false,
      stammdaten: {} as Kommune,
      newTermin: { datum: new Date().getTime() },
      openSaveDialog: false,
      regionalstellen: [] as Regionalstelle[],
      ibhHpis: [] as IBH[],
      gewzv: [] as Gewzv[],
      rollen: [] as Rolle[],
      hochwasserpartnerschaften: [] as Hochwasserpartnerschaften[],
      gewaesserzweckverbaende: [],
      risikogewaesser: [] as Risikogewaesser[],
      schlagworte: [] as Schlagwort[],
      tableTermineHeader: [
        {
          field: "datum",
          label: "Datum",
          type: "date",
          sortable: true,
        },
        { field: "thema", label: "Thema", sortable: true },
      ] as Header[],
    };
  },
  mounted() {
    this.isLoading = true;

    Promise.all([
      erklServiceInstance
        .getSchlagworte()
        .then((data: Schlagwort[]) => (this.schlagworte = data)),

      erklServiceInstance
        .getRegionalstellen()
        .then((data: Regionalstelle[]) => (this.regionalstellen = data)),

      erklServiceInstance
        .getIbhDaten()
        .then((data: IBH[]) => (this.ibhHpis = data)),

      erklServiceInstance
        .getHwpDaten()
        .then(
          (data: Hochwasserpartnerschaften[]) =>
            (this.hochwasserpartnerschaften = data),
        ),

      erklServiceInstance
        .getRisikogewaesser()
        .then((data: Risikogewaesser[]) => (this.risikogewaesser = data)),

      erklServiceInstance
        .getGewzv()
        .then((data: Gewzv[]) => (this.gewzv = data)),

      erklServiceInstance
        .getRollen()
        .then((data: Rolle[]) => (this.rollen = data)),

      kommunenServiceInstance
        .getKommune(this.id)
        .then((data: Kommune) => (this.stammdaten = data)),
    ])
      .then(() => this.$emit("loaded", this.stammdaten))
      .catch((error: any) => alertError(error))
      .finally(() => (this.isLoading = false));
  },
  methods: {
    resetAnsprechpartner: function (data: Ansprechpartner) {
      const items = this.stammdaten.ansprechpartner.map((x) =>
        x.id === data.id
          ? {
              ...x,
              rollen: [],
              namen: [],
              telefon: "",
              email: "",
              bemerkung: "",
            }
          : x,
      );
      this.stammdaten.ansprechpartner = items;
    },

    removeAnsprechpartner: function (data: Ansprechpartner) {
      const items = this.stammdaten.ansprechpartner.map((x) =>
        x.id === data.id
          ? { ...x, rollen: [], telefon: "", email: "", bemerkung: "" }
          : x,
      );
      this.stammdaten.ansprechpartner = items;
    },

    getAnsprechpartner: function (data: Ansprechpartner) {
      const items = this.stammdaten.ansprechpartner.map((x) =>
        x.id === data.id ? data : x,
      );
      this.stammdaten.ansprechpartner = items;
    },

    bearbeiten: function (mode: boolean) {
      PubSub.publish("bearbeiten", mode);
    },
    onSaveConfirm() {
      this.isLoading = true;
      kommunenServiceInstance
        .updateKommune(this.id, this.stammdaten)
        .then((data: Kommune) => {
          if (data) this.stammdaten = data;
          AlertService.info("Stammdaten gespeichert!");
        })
        .catch((error: RequestError) => {
          AlertService.error(
            "Beim Speichern ist ein Fehler aufgetreten!",
            "Bitte versuchen Sie es in einiger Zeit erneut!",
            "Wenn das Problem weiterhin besteht, informieren Sie bitte den Helpdesk!",
            "Fehlermeldung: " + error.message,
          );
        })
        .finally(() => (this.isLoading = false));
    },
    validateAndSave() {
      let valid = true;
      for (const ansprechpartner of this.stammdaten.ansprechpartner) {
        if (!ValidationService.validEmail(ansprechpartner.email)) {
          valid = false;
          break;
        }
      }
      if (valid) this.openSaveDialog = true;
      else AlertService.error("Die Emailaddresse(n) sind nicht valide!");
    },
  },
});
